import { TAB_EVENTS, getActiveTab, setActiveClass, updateUrlHistory } from "./magazine-helpers";

export const magazineTabClickHandler = (tabList: string[], basePath: string): void => {
  const filterContainer = document.querySelector<HTMLElement>(".js-magazine-filter");

  if (filterContainer === null || filterContainer.dataset.is_magazine_page !== "true") return;

  const children = [...filterContainer.children] as HTMLElement[];

  if (children === null) return;

  const initialTag = getActiveTab(tabList);
  if (initialTag !== null) setActiveClass(initialTag, children);

  for (const element of children) {
    element.addEventListener("click", (e: MouseEvent) => {
      e.preventDefault();
      const clickedElement = e.target as HTMLElement;
      if (clickedElement.dataset.sideScrollActive !== undefined) return;

      const newTag = clickedElement.dataset.value as string;
      setActiveClass(newTag, children);
      updateUrlHistory(newTag, basePath);
      document.dispatchEvent(
        new CustomEvent(TAB_EVENTS.UPDATE_MAGAZINE_FILTER, {
          detail: {
            filter: newTag,
          },
        }),
      );
    });
  }
};
